export default "__VITE_ASSET__DaIaM29a__"